module.exports = __webpack_public_path__ + "media/images/sp/stores/karuizawa/karuizawa_sns_02-63ce802bcb9c037aaf03e15e957d2ef9.jpg";